export default __webpack_public_path__ + "static/media/picture.7ca906fa.svg";